import { useTranslation } from 'react-i18next';

import { Icon } from './icon';
import { NavLink } from './nav-link';
import { SITE_UI } from '@site-ui';
import { localePath } from '../lib/format';
import { useLocale } from '@todo/core/i18n/use-locale';

import css from './category-strip.module.css';

// The band of category links under the hero: line icon over a two-line label,
// thin dividers between eight equal columns (a 4×2 grid on phones).
export function CategoryStrip() {
  const { t } = useTranslation();
  const { locale } = useLocale();

  return (
    <nav aria-label={t('a11y.categories')} className={css.band}>
      <ul className={css.grid}>
        {SITE_UI.categoryStrip.map((item) => {
          const [slug, label, icon] =
            item.kind === 'page'
              ? [item.path, t(item.labelKey), item.icon]
              : [item.collection.slug, t(`collections.${item.collection.slug}.short`), item.collection.icon];
          return (
            <li key={slug} className={css.cell}>
              <NavLink href={localePath(locale, slug)} className={css.link}>
                <Icon d={icon} size={34} strokeWidth={1.1} className={css.icon} />
                <span className={css.label}>{label}</span>
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
